module.exports = __webpack_public_path__ + "media/images/client-30-0dd79bceacaf17b319ff22edcb60e713.png";